module.exports = __webpack_public_path__ + "img/fig10.c42c7556.jpg";